import React from 'react';
import {
	Container,
	ContainerGutter,
	CTA,
	List,
	ListGutter,
	ListItem,
	Text,
	TokenTextAppearance,
	TokenTextColor,
} from '@volkswagen-onehub/components-core';
import { ServiceGroupType, ServiceLayer } from '../../models/services-layer-types';

export const idCareLayer: ServiceLayer = {
	id: ServiceGroupType.Coberturas,
	header: 'Coberturas',
	title: 'ID. Care',
	subtitle: (
		<Container wrap="always" gutter={ContainerGutter.static300}>
			<Text appearance={TokenTextAppearance.copy200}>
				Este servicio para clientes que conducen un modelo 100% eléctrico se renueva cada 2 años y ofrece una cobertura
				adicional de hasta 8 años ante averías eléctricas y/o mecánicas.
			</Text>
			<Text appearance={TokenTextAppearance.copy200}>
				Al realizar la inspección de tu modelo en un Servicio Oficial Volkswagen, recibirás el Certificado ID. Care, que
				podrás utilizar hasta la siguiente inspección o hasta recorrer 160.000km con tu coche, lo que antes ocurra.
			</Text>
		</Container>
	),
	description: (
		<Container wrap="always" gutter={ContainerGutter.dynamic0100}>
			<Text appearance={TokenTextAppearance.headline200} bold>
				Al activarlo, tú te relajas y nosotros revisamos:
			</Text>
			<Text appearance={TokenTextAppearance.copy200}>
				<List gutter={ListGutter.dynamic0020}>
					<ListItem>Sistema de refrigeración</ListItem>
					<ListItem>Sistema de propulsión</ListItem>
					<ListItem>Suspensión</ListItem>
					<ListItem>Dirección</ListItem>
					<ListItem>Frenos</ListItem>
					<ListItem>Sistemas de climatización</ListItem>
					<ListItem>Sistema eléctrico</ListItem>
				</List>
			</Text>
		</Container>
	),
	imageContent:
		'https://assets.volkswagen.com/is/image/volkswagenag/layer-id-care?Zml0PWNyb3AlMkMxJndpZD04OTYmaGVpPTg5NiZmbXQ9anBlZyZxbHQ9NzkmYmZjPW9mZiZlMmRh',
	ctaText: 'Quiero mi ID. Care',
	link: 'action:es-cca-loader--open_layer',
	descriptionFooter: (
		<Container wrap="always" gutter={ContainerGutter.dynamic0130}>
			<Text appearance={TokenTextAppearance.copy200}>
				Para beneficiarse de ID. Care será imprescindible cumplir con las condiciones del servicio y acreditar por parte
				del cliente la total realización del Plan de Asistencia Técnica del coche conforme a las recomendaciones del
				fabricante. El servicio ID. Care no incluye la cobertura ante averías causadas por holguras o desajustes sin
				rotura de pieza, averías producidas por un mal uso del coche, averías producidas por el uso de recambios o
				accesorios no originales, averías por manipulación del coche, daños por accidente ni ante el incumplimiento del
				Plan de Asistencia Técnica.
			</Text>
			<Text appearance={TokenTextAppearance.copy200}>
				<CTA
					tag="a"
					emphasis="tertiary"
					href="https://www.volkswagen.es/idhub/content/dam/onehub_pkw/importers/es/clientes/4-mantenimiento-y-reparaciones/electricos/Volkswagen_Condiciones-servicio-ID-Care.pdf"
					aria-label="Consulta las condiciones del servicio ID. Care"
				>
					<Text color={TokenTextColor.primary}>Consulta las condiciones del servicio ID. Care</Text>
				</CTA>
			</Text>
		</Container>
	),
};
